// This file is generated using scripts/generate-icon-components/utils.js
// Don't edit it manually

import React from 'react';

const IconLinearShoppingCart = (
  {
    size,
    style,
    ...rest
  }: React.HTMLAttributes<SVGElement> & { size?: number } /*#__PURE__*/,
) =>
  React.createElement(
    'svg',
    {
      style: { width: size, height: size, ...style },
      ...rest,
      width: '24',
      height: '24',
      viewBox: '0 0 16 16',
      fill: 'none',
      xmlns: 'http://www.w3.org/2000/svg',
    },
    /*#__PURE__*/ React.createElement('path', {
      d: 'M1.33301 1.33337H2.49301C3.21301 1.33337 3.77968 1.95337 3.71968 2.66671L3.16634 9.3067C3.07301 10.3934 3.933 11.3267 5.02634 11.3267H12.1263C13.0863 11.3267 13.9263 10.54 13.9997 9.58671L14.3597 4.58671C14.4397 3.48004 13.5997 2.58004 12.4863 2.58004H3.87968',
      stroke: 'currentColor',
      strokeMiterlimit: '10',
      strokeLinecap: 'round',
      strokeLinejoin: 'round',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M10.8333 14.6667C11.2936 14.6667 11.6667 14.2936 11.6667 13.8333C11.6667 13.3731 11.2936 13 10.8333 13C10.3731 13 10 13.3731 10 13.8333C10 14.2936 10.3731 14.6667 10.8333 14.6667Z',
      stroke: 'currentColor',
      strokeMiterlimit: '10',
      strokeLinecap: 'round',
      strokeLinejoin: 'round',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M5.50033 14.6667C5.96056 14.6667 6.33366 14.2936 6.33366 13.8333C6.33366 13.3731 5.96056 13 5.50033 13C5.04009 13 4.66699 13.3731 4.66699 13.8333C4.66699 14.2936 5.04009 14.6667 5.50033 14.6667Z',
      stroke: 'currentColor',
      strokeMiterlimit: '10',
      strokeLinecap: 'round',
      strokeLinejoin: 'round',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M6 5.33337H14',
      stroke: 'currentColor',
      strokeMiterlimit: '10',
      strokeLinecap: 'round',
      strokeLinejoin: 'round',
    }),
  );

export { IconLinearShoppingCart };
